import {CommandCaller} from '../lib/commands'

export class Commands {

	constructor(private ajaxPageUrl:string) {}

	public isFolderEmpty(folderId:number):Promise<boolean> {
		return new CommandCaller(this.ajaxPageUrl).runGet('is folder empty', folderId) as Promise<boolean>
	}
}



// WEBPACK FOOTER //
// ./src/memory/Commands.ts